function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class FeatureShadeSlider extends SliderComponent {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.prevButton = this.querySelector('.feature-shade__prev-arrow');
    this.nextButton = this.querySelector('.feature-shade__next-arrow');
    
    if (!this.slider || !this.prevButton || !this.nextButton) return;
    
    this.initFeatureShade();
    this.slider.addEventListener('scroll', this.updateButtons.bind(this));
    this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
    this.nextButton.addEventListener('click', this.onNextClick.bind(this));
    
    // Initial button state
    this.updateButtons();
  }
  
  initFeatureShade() {
    this.itemWidth = this.slider.clientWidth * 0.4; // 40% width per item
    this.gap = parseFloat(getComputedStyle(this.slider).gap) || 20;
    this.scrollAmount = this.itemWidth + this.gap;
  }
  
  updateButtons() {
    const scrollLeft = this.slider.scrollLeft;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
    
    // Update prev button
    if (scrollLeft <= 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    
    // Update next button
    if (scrollLeft >= maxScroll - 1) { // -1 for rounding errors
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
  
  onPrevClick(event) {
    event.preventDefault();
    this.slider.scrollBy({
      left: -this.scrollAmount,
      behavior: 'smooth'
    });
  }
  
  onNextClick(event) {
    event.preventDefault();
    this.slider.scrollBy({
      left: this.scrollAmount,
      behavior: 'smooth'
    });
  }
}

// Only define if we have feature shade sliders
if (document.querySelector('.feature-shade__slider-component')) {
  customElements.define('feature-shade-slider', FeatureShadeSlider);
}

class ImageTextSlider extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.autoPlayInterval = null;
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }
  
  init() {
    this.setupElements();
    this.bindEvents();
    
    this.switchToSlide(0);
    
    if (this.dataset.autoPlay === 'true') {
      this.startAutoPlay();
    }
  }
  
  setupElements() {
    this.progressSegments = Array.from(this.querySelectorAll('.progress-segment'));
    this.slideContents = Array.from(this.querySelectorAll('.slide-content'));
    this.slideImages = Array.from(this.querySelectorAll('.slide-image'));
    this.prevArrow = this.querySelector('.progress-arrow--prev');
    this.nextArrow = this.querySelector('.progress-arrow--next');
    this.progressFill = this.querySelector('.progress-fill');
  }
  
  bindEvents() {
    // Click handlers for progress segments
    this.progressSegments.forEach((segment, index) => {
      segment.addEventListener('click', () => {
        this.restartAutoPlay();
        this.switchToSlide(index);
      });
    });
    
    // Arrow button handlers
    if (this.prevArrow) {
      this.prevArrow.addEventListener('click', () => {
        this.restartAutoPlay();
        this.goToPrevSlide();
      });
    }
    
    if (this.nextArrow) {
      this.nextArrow.addEventListener('click', () => {
        this.restartAutoPlay();
        this.goToNextSlide();
      });
    }
    
    if (this.dataset.autoPlay === 'true') {
      this.addEventListener('mouseenter', () => this.stopAutoPlay());
      this.addEventListener('mouseleave', () => this.startAutoPlay());
    }
  }
  
  switchToSlide(slideIndex) {
    if (slideIndex < 0 || slideIndex >= this.progressSegments.length) return;
    
    this.progressSegments.forEach((segment, index) => {
      segment.classList.toggle('active', index === slideIndex);
    });
    
    this.slideContents.forEach((content, index) => {
      content.style.display = index === slideIndex ? 'block' : 'none';
    });
    
    this.slideImages.forEach((image, index) => {
      image.style.display = index === slideIndex ? 'block' : 'none';
    });
    
    if (this.progressFill && this.progressSegments.length > 0) {
      const progressPercent = ((slideIndex + 1) / this.progressSegments.length) * 100;
      this.progressFill.style.width = `${progressPercent}%`;
    }
    
    this.updateArrowStates(slideIndex);
    
    this.currentSlide = slideIndex;
  }
  
  updateArrowStates(slideIndex) {
    if (this.prevArrow) {
      this.prevArrow.disabled = slideIndex === 0;
    }
    
    if (this.nextArrow) {
      this.nextArrow.disabled = slideIndex === this.progressSegments.length - 1;
    }
  }
  
  goToPrevSlide() {
    if (this.currentSlide > 0) {
      this.switchToSlide(this.currentSlide - 1);
    }
  }
  
  goToNextSlide() {
    if (this.currentSlide < this.progressSegments.length - 1) {
      this.switchToSlide(this.currentSlide + 1);
    }
  }
  
  restartAutoPlay() {
    if (this.dataset.autoPlay === 'true') {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
  }
  
  startAutoPlay() {
    if (this.dataset.autoPlay !== 'true' || this.progressSegments.length <= 1) return;
    
    this.stopAutoPlay(); 
    
    const speed = parseInt(this.dataset.autoPlaySpeed) || 5000;
    this.autoPlayInterval = setInterval(() => {
      const nextSlide = (this.currentSlide + 1) % this.progressSegments.length;
      this.switchToSlide(nextSlide);
    }, speed);
  }
  
  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
  
  disconnectedCallback() {
    this.stopAutoPlay();
  }
}

customElements.define('image-text-slider', ImageTextSlider);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateShadeLabel();

    if (!this.currentVariant) {
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateShareUrl();

      const isBackOrder = this.currentVariant.inventory_quantity <= 0 && this.currentVariant.inventory_policy === 'continue';
      if (isBackOrder) {
        const backOrderText = this.currentVariant.back_order_text || "PREORDER";
        this.toggleAddButton(false, window.variantStrings.backOrder);
        this.updateBackOrderStatus(backOrderText);
      } else if (!this.currentVariant.available) {
        this.toggleAddButton(true, window.variantStrings.soldOut);
        this.updateBackOrderStatus('');
      } else {
        this.updateButtonBasedOnSubscription(this.currentVariant.price);
        this.updateBackOrderStatus('');
      }
    }

    document.dispatchEvent(new CustomEvent('variant:changed', {
      detail: { variant: this.currentVariant }
    }));
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateShadeLabel() {
    // Handle both radio inputs (VariantRadios) and select dropdowns (VariantSelects)
    const selectedInput = this.querySelector('input[name="Shade"]:checked');
    const selectedSelect = this.querySelector('select[name="options[Shade]"]');
    
    if (selectedInput) {
      // Handle radio inputs (VariantRadios)
      const labelForSelectedInput = this.querySelector(`label[for="${selectedInput.id}"]`);
      const shadeName = labelForSelectedInput.getAttribute('data-shade-name');
      const shadeLegend = this.querySelector('.form__label > span');
      if (shadeLegend) shadeLegend.textContent = shadeName;
      const shadeValue = labelForSelectedInput.getAttribute('data-option');
      const shadeValueField = document.getElementById('shade__value-field');
      const shadeMetafieldName = document.getElementById('shade-metafield__name');
      
      if (shadeValueField) {
        shadeValueField.textContent = shadeValue;
      }
      
      if (shadeMetafieldName) {
        shadeMetafieldName.textContent = shadeName;
      }
    } else if (selectedSelect && selectedSelect.value) {
      const selectedValue = selectedSelect.value;
      const shadeValueField = document.getElementById('shade__value-field');
      const shadeMetafieldName = document.getElementById('shade-metafield__name');
      
      if (shadeValueField) {
        shadeValueField.textContent = selectedValue;
      }
      
      if (this.currentVariant && this.currentVariant.metafields && this.currentVariant.metafields.custom && this.currentVariant.metafields.custom.shade_name) {
        if (shadeMetafieldName) {
          shadeMetafieldName.textContent = this.currentVariant.metafields.custom.shade_name;
        }
      } else if (shadeMetafieldName) {
        shadeMetafieldName.textContent = selectedValue;
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);

    // Update Feature Shade content
    this.updateFeatureShadeContent();
  }

  updateFeatureShadeContent() {
    if (!this.currentVariant) return;

    const featureShadeSection = document.querySelector('.feature-shade__section');
    if (!featureShadeSection) return;

    const sectionId = featureShadeSection.dataset.sectionId;
    const dataScript = document.getElementById(`FeatureShadeData-${sectionId}`);
    
    if (!dataScript) return;

    try {
      const variantData = JSON.parse(dataScript.textContent);
      const currentVariantData = variantData[this.currentVariant.id];
      
      if (!currentVariantData) {
        featureShadeSection.style.display = 'none';
        return;
      }

      featureShadeSection.style.display = '';

      const headingElement = document.querySelector('.feature-shade__heading-text');
      if (headingElement && currentVariantData.heading) {
        headingElement.textContent = currentVariantData.heading;
      }

      const descriptionElement = document.querySelector('.feature-shade__description-content');
      if (descriptionElement && currentVariantData.description) {
        descriptionElement.innerHTML = currentVariantData.description;
      }

      const sliderContainer = document.querySelector('.feature-shade__grid');
      if (sliderContainer && currentVariantData.images) {
        sliderContainer.innerHTML = currentVariantData.images.map((image, index) => `
          <div class="feature-shade__grid-item" id="Slide-${sectionId}-${index + 1}">
            <img
              src="${image.url}"
              sizes="(min-width: 990px) 25vw, (min-width: 750px) 50vw, 40vw"
              alt="${image.alt || ''}"
              height="${image.height}"
              width="${image.width}"
              loading="lazy"
            >
          </div>
        `).join('');

        const sliderComponent = document.querySelector('.feature-shade__slider-component');
        if (sliderComponent && sliderComponent.updateButtons) {
          sliderComponent.updateButtons();
        }
      }
    } catch (error) {
      console.error('Error updating feature shade content:', error);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('#add-to-cart__action');
    const addButtonText = addButton.querySelector('#btn-text'); 

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (addButtonText) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) {
        addButtonText.textContent = text;
      }
    }
  }

  updateBackOrderStatus(text) {
    const backOrderStatusElement = document.querySelector('.product-back-order__status');
    if (backOrderStatusElement) {
      let statusBackorder = backOrderStatusElement.querySelector('.statusBackorder');
      if (statusBackorder) {
        statusBackorder.textContent = text;
      } else if (text !== '') {
        statusBackorder = document.createElement('span');
        statusBackorder.className = 'statusBackorder';
        statusBackorder.textContent = text;
        backOrderStatusElement.appendChild(statusBackorder);
      }
    }
  }

  updateButtonPrice(price) {
    const priceElement = document.querySelector('#btn-price');
    if (priceElement) {
      priceElement.textContent = `$${(price / 100).toFixed(2)}`;
    }
  }

  setUnavailable() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#btn-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateButtonBasedOnSubscription(defaultPrice) {
    const oneTimeSelected = document.querySelector('input[skio-one-time]:checked');
    const subscriptionSelected = document.querySelector('input[skio-selling-plan-group]:checked');

    const addButton = document.querySelector('#add-to-cart__action');
    const addButtonText = addButton.querySelector('#btn-text');
    const priceElement = document.querySelector('#btn-price');

    if (oneTimeSelected) {
      const oneTimePrice = oneTimeSelected.closest('.skio-group-container').querySelector('[skio-onetime-price]').textContent;
      addButtonText.textContent = "Add to cart | ";
      priceElement.textContent = oneTimePrice; 
    } else if (subscriptionSelected) {
      const subscriptionPrice = subscriptionSelected.closest('.skio-group-container').querySelector('[skio-subscription-price]').textContent;
      addButtonText.textContent = "Subscribe Now | ";
      priceElement.textContent = subscriptionPrice;
    } else {
      addButtonText.textContent = "Add to cart | ";
      priceElement.textContent = `$${(defaultPrice / 100).toFixed(2)}`;
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


class BundleVariantRadios extends HTMLElement {
  constructor() {
    super();
    this.attachListeners();
    this.checkIfAllSelected();
  }

  attachListeners() {
    this.addEventListener('click', (event) => {
      if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
        this.updateSelectedOption(event.target);
        this.checkIfAllSelected();
      }
    });

    this.addEventListener('mouseover', (event) => {
      if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
        this.updateImageOnHover(event.target);
      }
    });

    this.addEventListener('mouseout', () => {
      this.resetImageToSelected();
    });
  }

  updateSelectedOption(selectedInput) {
    const productId = this.getAttribute('data-product-id');
    const shadeNameElement = document.querySelector(`.bundle-${productId}-shade`);
    const productImageElement = document.querySelector(`.bundle-${productId}-image`);
    const shadeColorNameElements = document.querySelectorAll('.shade-color__name');

    if (shadeNameElement) {
      shadeNameElement.textContent = selectedInput.getAttribute('data-shade-name');
    }

    if (productImageElement) {
      productImageElement.src = selectedInput.getAttribute('data-featured-image');
    }

    const selectedValue = selectedInput.value;
    const selectedLabel = document.querySelector(`label[for="${selectedInput.id}"]`);
    const selectedName = selectedLabel ? selectedLabel.nextElementSibling.textContent.trim() : '';

    shadeColorNameElements.forEach(element => {
      if (element.closest(`[data-product-id="${productId}"]`)) {
        if (selectedName && selectedName !== 'Default Title') {
          element.textContent = selectedName;
        } else {
          element.textContent = '';
        }
      }
    });

    const hiddenInput = document.querySelector(`#hidden-input-${productId}`);
    if (hiddenInput) {
      hiddenInput.value = selectedInput.value;
    }
  }

  updateImageOnHover(hoveredInput) {
    const productId = this.getAttribute('data-product-id');
    const productImageElement = document.querySelector(`.bundle-${productId}-image`);

    if (productImageElement) {
      productImageElement.src = hoveredInput.getAttribute('data-featured-image');
    }
  }

  resetImageToSelected() {
    const productId = this.getAttribute('data-product-id');
    const selectedInput = this.querySelector('input[type="radio"]:checked');
    const productImageElement = document.querySelector(`.bundle-${productId}-image`);

    if (productImageElement && selectedInput) {
      productImageElement.src = selectedInput.getAttribute('data-featured-image');
    }
  }

  checkIfAllSelected() {
    const fieldsets = document.querySelectorAll('.bundle-swatch-container');
    let allSelected = true;
  
    fieldsets.forEach((fieldset) => {
      const selected = fieldset.querySelector('input[type="radio"]:checked');
      if (!selected) {
        allSelected = false;
      }
    });
  
    const addButton = document.getElementById('bundle-buy-button');
    const buttonText = document.getElementById('btn-text');
  
    if (allSelected) {
      addButton.removeAttribute('disabled');
      buttonText.textContent = 'Add to Cart | '; 
    } else {
      addButton.setAttribute('disabled', 'disabled');
      buttonText.textContent = 'Select Shade | ';
    }
  }
}

customElements.define('bundle-variant-radios', BundleVariantRadios);

document.addEventListener('rebuy:cart.change', function(event) {
  updateHeaderCartCount();
});

document.addEventListener('rebuy:cart.add', function(event) {
  updateHeaderCartCount();
});

function updateHeaderCartCount() {
  if (!window.Rebuy?.SmartCart) {
    console.warn('Rebuy SmartCart is not initialized yet');
    return;
  }

  const totalQuantity = window.Rebuy.SmartCart.itemCount();
  const cartCounter = document.querySelector('.cart-count-bubble span');

  
  if (cartCounter) {
    cartCounter.textContent = totalQuantity;
  }
  
  const visuallyHidden = document.querySelector('.cart-count-bubble .visually-hidden');
  if (visuallyHidden) {
    visuallyHidden.textContent = `${totalQuantity} items`;
  }
}

document.addEventListener('rebuy.ready', function() {
  updateHeaderCartCount();
});



class MobileSearchTrigger extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    const searchTrigger = this.querySelector('.js-search-container');
    const menuDrawer = document.getElementById('Details-menu-drawer-container');
    const searchModal = document.querySelector('details-modal.header__search');

    if (!searchTrigger || !searchModal) return;

    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const details = searchModal.querySelector('details');
      if (details) {
        details.setAttribute('open', '');
        const searchInput = details.querySelector('input[type="search"]');
        if (searchInput) searchInput.focus();
      }
      // Close menu drawer immediately
      if (menuDrawer) {
        setTimeout(() => {
          menuDrawer.removeAttribute('open');
          menuDrawer.classList.remove('menu-opening');
          document.body.classList.remove('overflow-hidden-tablet');
          
        // Update aria-expanded on the summary element
        const menuSummary = menuDrawer.querySelector('summary');
        if (menuSummary) {
          menuSummary.setAttribute('aria-expanded', 'false');
        }
      }, 100);
      }


    });
  }
}

customElements.define('mobile-search-trigger', MobileSearchTrigger);



